import React from 'react';
import "./EmptyPlayerProfile.scss";
import playIcon from "../../assets/imgs/triangle-copy.svg";

const EmptyPlayerProfile = ()=> {
  return(
    <div className="empty-player-profile">
      <div className="empty-player-profile__thumbnail">
        <img src={playIcon} alt=''/>
      </div>
      <div className="empty-player-profile__thumbnail">
        <img src={playIcon} alt=''/>
      </div>
      <div className="empty-player-profile__thumbnail">
        <img src={playIcon} alt=''/>
      </div>
      <div className="empty-player-profile__thumbnail">
        <img src={playIcon} alt=''/>
      </div>
    </div>
  )
}

export default EmptyPlayerProfile
